import * as _ from 'underscore';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';

// Note: This file can be deleted once tbTimePicker is no longer used by serverSettingsMixin.pug

interface ITimePickerAttributes extends ng.IAttributes {
  precision?: string; // no value indicates default precision of hours/minutes, "hours" indicates precision of hours
}

interface ITimePickerScope extends ng.IScope {
  use24HourTimeCycle: boolean;
  precisionIncludesMinutes: boolean;
  hours: number[];
  minutes: number[];
  time: {
    hour: number;
    minute: number;
    meridiem?: string;
  };
}

Module.instance().directive('tbTimePicker', <any[]>[
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'timePicker.html',
      require: '?ngModel',
      scope: {},
      link: (scope: ITimePickerScope, elm: JQuery, attrs: ITimePickerAttributes, ngModel: ng.INgModelController) => {

        if (!ngModel) return; // do nothing if no ng-model

        const use24HourTimeCycle = L10n.is24HourTimeCycle();

        scope.use24HourTimeCycle = use24HourTimeCycle;
        scope.precisionIncludesMinutes = attrs.precision !== 'hours';

        scope.hours = use24HourTimeCycle ? _.range(0, 24) : _.range(1, 13);
        scope.minutes = _.range(0, 60, 15);

        // View -> Model
        function modelValueFromView(): number {
          let minutesAfterMidnight = scope.time.minute;

          const hour = scope.time.hour;

          if (use24HourTimeCycle) {
            // 24-hr time

            minutesAfterMidnight += hour * 60;

          } else {
            // 12-hr time

            if (hour !== 12) {
              minutesAfterMidnight += hour * 60;
            }
            if (scope.time.meridiem === 'PM') {
              minutesAfterMidnight += 60 * 12;
            }
          }

          return minutesAfterMidnight;
        }
        scope.$watch(modelValueFromView, (newValue: number) => {
          ngModel.$setViewValue(newValue);
        });

        // Model -> View
        ngModel.$render = () => {
          let minutesAfterMidnight = ngModel.$viewValue;
          if (!(0 <= minutesAfterMidnight && minutesAfterMidnight <= 24 * 60)) {
            minutesAfterMidnight = 0;
            ngModel.$setViewValue(0);
          }

          if (use24HourTimeCycle) {

            scope.time = {
              hour: Math.floor(minutesAfterMidnight / 60),
              minute: minutesAfterMidnight % 60
            };

          } else {
            const hours = Math.floor(minutesAfterMidnight / 60) % 12;

            scope.time = {
              hour: hours > 0 ? hours : 12,
              minute: minutesAfterMidnight % 60,
              meridiem: minutesAfterMidnight >= 12 * 60 ? 'PM' : 'AM'
            };
          }
        };
      }
    };
  }
]);
